import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { daterange, device, InsightsFilter } from './insights.model';
import { toHttpParams } from '../project/helpers/to-http-params';

const BASE_URL = `${environment.analytics.url}/internal/studio-insights/traffic/project`;

@Injectable()
export class InsightsService {
  constructor(private http: HttpClient) {}

  loadInsights(
    projectId: number,
    params: { daterange: daterange; device: device } = { daterange: 'week', device: 'all' },
  ) {
    return this.http.get(`${BASE_URL}/${projectId}`, { params });
  }

  loadInsightsCsv(projectId: number, filter: InsightsFilter) {
    const params = toHttpParams({
      daterange: filter?.daterange ?? 'week',
      device: filter?.device ?? 'all',
      dataFormat: 'csv',
      chartDataTypes: filter?.chartDataTypes ?? undefined,
    });
    return this.http.get(`${BASE_URL}/${projectId}`, {
      params,
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob',
    });
  }
}
